"use client";

import { ReactNode, MouseEventHandler } from "react";

interface BaseCardProps {
  title?: string;
  padding?: boolean;
  hoverable?: boolean;
  clickable?: boolean;
  header?: ReactNode;
  footer?: ReactNode;
  className?: string;
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  onMouseEnter?: MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: MouseEventHandler<HTMLDivElement>;
}

export function BaseCard({
  title,
  padding = true,
  hoverable = false,
  clickable = false,
  header,
  footer,
  className,
  children,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: BaseCardProps) {
  const cardClasses = [
    "bg-secondary border border-primary rounded-lg overflow-hidden",
    hoverable || onClick ? "transition-colors duration-100 hover:bg-hover" : "",
    clickable || onClick ? "cursor-pointer" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const bodyClasses = padding ? "px-meta-3 sm:px-meta-4 py-meta-3" : "";

  return (
    <div
      className={cardClasses}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick(e as any);
              }
            }
          : undefined
      }
    >
      {(header || title) && (
        <div className="px-meta-3 sm:px-meta-4 py-meta-3 border-b border-primary">
          {header || (
            <h3 className="text-meta-lg font-semibold text-primary">{title}</h3>
          )}
        </div>
      )}
      <div className={bodyClasses}>{children}</div>
      {footer && (
        <div className="px-meta-3 sm:px-meta-4 py-meta-3 border-t border-primary bg-tertiary">
          {footer}
        </div>
      )}
    </div>
  );
}
